module.exports = __webpack_public_path__ + "img/going_up.be314852.svg";